<template>
  <template v-if="isFooterVisible">
    <slot />
  </template>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from '@core/composables/use-router';
import { FeatureFlag, isEnabled } from '@monolith/legacy/services/features';

const HIDDEN_FOOTER_ROUTE_NAMES = ['carts', 'checkout', 'payment'];

const route = useRoute();

const isFooterVisible = computed(
  () => !(HIDDEN_FOOTER_ROUTE_NAMES.includes(route.value.name as string) && !isEnabled(FeatureFlag.DisableNewCartUi))
);
</script>
